import styled from 'styled-components';

// COLORS
import { SEA_GREEN, WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

const Container = styled.div`
  position: relative;
  padding: 40px 0;
  background-color: ${SEA_GREEN};

  &::after,
  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    background-color: inherit;
    z-index: 0;
  }

  &::before {
    right: 100%;
  }

  &::after {
    left: 100%;
  }

  .banner-save-your-apps {
    &__content-img {
      z-index: 2;
    }

    &__title {
      line-height: 4rem;

      color: ${WHITE};
    }

    &__subtitle {
      margin: 8px 0;

      color: ${WHITE};
    }

    &__image {
      img {
        width: 100%;
        max-width: 390px;
      }
    }

    &__button {
      max-width: 210px;
    }

    &__bg-image {
      position: absolute;
      top: 0;

      width: 139px;
      z-index: 1;

      transform: translateX(-16px);
    }

    ${breakpoints.up('sm')} {
      &__content-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }

    ${breakpoints.up('md')} {
      &__title {
        font-weight: 600;
        font-size: 3.6rem;
        line-height: 4.2rem;
      }

      &__subtitle {
        margin: 21px 0;

        font-size: 1.8rem;
        line-height: 3rem;
      }
    }

    ${breakpoints.up(1144)} {
      &__bg-image {
        transform: translateX(-156px);
      }
    }
  }
`;

export default Container;
